import React, { useEffect } from "react";
import { BrowserRouter as Router, useRoutes } from "react-router-dom";
import AuthorizedRoutes from "./AutherizedRoute";
import UnAuthorizedRoutes from "./UnAutherizedAoutes";
import MaintenanceRoute from "./MaintenanceRoute";
import AdminRoute from "./AdminRoute";


const AppRoutes:React.FC = () => {
    // useEffect(()=>{
    //     const logRoutes = (routeList:any) => {
    //         routeList.forEach((route:any) => {
    //           console.log(`Route path: ${route.path}, Component: ${route.element.type.name}`);
    //           if (route.children) {
    //             logRoutes(route.children); // Recursively log child routes
    //           }
    //         });
    //       };
    //       logRoutes([UnAuthorizedRoutes, UnAuthorizedRoutes, MaintenanceRoute]);
    // },[])

    // useEffect(() => {
    // const logRoutes = (routes: any, parentPath = "") => {
    //     routes.forEach((route: any) => {
    //         const fullPath = route.path?.startsWith("/") ? route.path : parentPath + "/" + route.path;
    //         console.log("Route:", fullPath, "Component:", route.element?.type?.name);
    //         if (route.children) logRoutes(route.children, fullPath);
    //     });
    // };
    // logRoutes([UnAuthorizedRoutes, AuthorizedRoutes, MaintenanceRoute, AdminRoute]);
    // }, []);

    const allRoutes = useRoutes([UnAuthorizedRoutes, AuthorizedRoutes, MaintenanceRoute, AdminRoute])
    // const allRoutes = useRoutes([ MaintenanceRoute ])
    return allRoutes
}

export default AppRoutes
